import {FETCH_PAYMENT_SUCCESS, PAY_ORDER_FAILURE, PAY_ORDER_SUCCESS} from "../actions/PaymentActions";

const initialState = {
    payments: undefined,
    defaultPaymentMethod: 1,
};

export default function PaymentReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PAYMENT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                payments: action.payload.payments ? action.payload.payments : null,
                defaultPaymentMethod: action.payload.payments ?
                    action.payload.payments[0]['pay_system_type'].toString() : 1,
            };
        case PAY_ORDER_SUCCESS:
            return window.location = action.payload;

        case PAY_ORDER_FAILURE:
            return {
                ...state,
                ...action.payload
            };
    }

    return state;
}